export const imageUtil = {
  getImageUrl: (fileId: string): string => {
    if (!fileId) {
      return ''
    }
    // Construct the API URL for the file download endpoint
    return `/files/${fileId}/download`
  },
}
